import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Layout from '../../layout/Layout'
import Spinner from '../../layout/Spinner'
import { api } from '../../utils/Api'
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom';

const Positions = () => {
    const [loading, setLoading] = useState(true)
    const [positionList, setPositionList] = useState([])

    useEffect(() => {
        search()
    }, [])

    const search = () => {
        getPositionListSearch()
    }

    const getPositionListSearch = async() => {
        setLoading(true)

        const url = api + `/position`
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            const { data } = await axios.get(url)
            setPositionList(data)
            setLoading(false)
        } catch (err) {
            console.error(err.message)
            return null
        }
    }

    const RenderLoading = () => {
        return <Spinner />
    }

    const RenderTable = () => {
        return <div style={{maxWidth: '100%', marginTop: 20}}>
            <table className="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Department</th>
                        <th>Active</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        positionList.length !== 0 ?
                        positionList.map((position) =>{
                            return (
                                <tr key={position._id}>
                                    <td><Link  to={'/position/'+position._id}>{`${position.name}`}</Link></td>
                                    <td>{position.department ? position.department.name : 'NA'}</td>
                                    <td>
                                        <input 
                                            type='checkbox'
                                            checked={position.active}
                                            readOnly
                                        />
                                    </td>
                                </tr>
                            )
                        })
                        :
                        <tr><td colSpan={7} className='text-center'>No positions to display</td></tr>
                    }
                </tbody>
            </table>
        </div>
    }    

    return (
        <Layout
            title='Positions'
            description='List all positions'
            className='container col-md-10'
        >
            <div>
                <Link
                    className='btn btn-success'
                    to='/newposition'
                >
                    <FontAwesomeIcon icon={faPlusSquare} />&nbsp;New
                </Link>
            </div>
            &nbsp;
            {
                loading ? <RenderLoading/> : <RenderTable/>
            } 
        </Layout>
    )
}

export default Positions